// extracted by mini-css-extract-plugin
export default {"container":"Subscription_container__PYAZ1"};